import React, { useState } from 'react';
import { Link as RouterLink, useSearchParams } from 'react-router-dom';
import { TextField, Button, Typography, Box, Alert, Link } from '@mui/material';
import AuthLayout from '../components/AuthLayout';
import { registration } from '../services/api';

const buttonSx = {
  py: 1.5, fontSize: '1rem', fontWeight: 700, borderRadius: '14px',
  background: 'linear-gradient(135deg, #19C6C0 0%, #11BDB6 100%)', boxShadow: '0 6px 20px rgba(25,198,192,0.4)',
};

// «Восстановить доступ»: a link to set a new password goes to the email (if it is registered).
const ForgotPasswordPage = () => {
  const [params] = useSearchParams();
  const [email, setEmail] = useState(params.get('email') || '');
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await registration.forgotPassword(email.trim());
      setSent(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Не удалось отправить письмо');
    }
    setLoading(false);
  };

  return (
    <AuthLayout subtitle="Восстановление доступа">
      {sent ? (
        <Alert severity="success" sx={{ borderRadius: '12px' }}>
          Если почта <b>{email}</b> зарегистрирована, мы отправили на неё ссылку для нового пароля. Ссылка действует 1 час.
          Проверьте папку «Спам», если письма нет.
        </Alert>
      ) : (
        <Box component="form" onSubmit={submit} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          {error && <Alert severity="error" sx={{ borderRadius: '12px' }}>{error}</Alert>}
          <Typography sx={{ fontSize: '0.875rem', color: '#6B7280' }}>
            Укажите почту, с которой вы регистрировались. Мы пришлём ссылку, чтобы задать новый пароль.
          </Typography>
          <TextField required fullWidth label="Email" type="email" autoComplete="email" autoFocus
            value={email} onChange={(e) => setEmail(e.target.value)} />
          <Button type="submit" fullWidth variant="contained" size="large" disabled={loading} sx={buttonSx}>
            {loading ? 'Отправка...' : 'Отправить ссылку'}
          </Button>
        </Box>
      )}
      <Typography sx={{ mt: 3, textAlign: 'center', fontSize: '0.875rem' }}>
        <Link component={RouterLink} to="/login" sx={{ fontWeight: 600, color: '#11BDB6' }}>Вернуться ко входу</Link>
      </Typography>
    </AuthLayout>
  );
};

export default ForgotPasswordPage;
